import "./Holiday.css";
import EventPage from "./Event/Event.jsx";
import lumpurImg from "../../../assets/Places/lumpur.png";
import singaporeImg from "../../../assets/Places/singapore.png";
import holidayAndamanImg from "../../../assets/holidays/andaman.png";
import holidayBeachEscapeImg from "../../../assets/holidays/beachescape.png";
import holidayGoaImg from "../../../assets/holidays/goa.png";
import holidayGujratImg from "../../../assets/holidays/gujrat.png";
import holidayHimachalImg from "../../../assets/holidays/himachal.png";
import holidayKeralaImg from "../../../assets/holidays/kerala.png";
import holidayManaliImg from "../../../assets/holidays/manali.png";
import holidayNorthEastImg from "../../../assets/holidays/northeast.png";
import holidayParisImg from "../../../assets/holidays/paris.png";
import holidayThailandImg from "../../../assets/holidays/thailand.png";
import heroSlide1 from "../../../assets/hero-top/slide1.png";
import heroSlide2 from "../../../assets/hero-top/slide2.png";
import heroSlide3 from "../../../assets/hero-top/slide3.png";
import heroSlide4 from "../../../assets/hero-top/slide4.png";
import {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  BadgePercent, Building2, CalendarDays, CheckCircle2, Clock3,
  Eraser,
  Globe, Headset, Heart, IndianRupee, Landmark, MapPin, Mountain,
  MessageCircle,
  MountainSnow, Palmtree, PawPrint, Phone, Plane, Search,
  ShieldCheck, Sparkles, Star, Target, Trophy, Users, XCircle
} from "lucide-react";
import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../../AuthProvider/AuthContext.jsx";
import usePageMeta from "../../../hooks/usePageMeta";



const API_BASE = (typeof process !== "undefined" && process.env?.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
  : ""
).replace(/\/$/, "") + "/api";

const ICONS = {
  Globe, Waves: Palmtree, Mountain, Landmark, HeartHandshake: Heart, Users,
  Trees: PawPrint, Church: Building2, Palmtree, Building2, MountainSnow,
  PawPrint, Heart,
};

/* ── Google Fonts ── */
const FONT_LINK = document.createElement("link");
FONT_LINK.rel = "stylesheet";
FONT_LINK.href =
  "https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap";
document.head.appendChild(FONT_LINK);

/* DATA */
const DESTINATIONS = [
  { name:"Goa",       country:"India", image:holidayGoaImg,       tagline:"Sun, Sand & Serenity" },
  { name:"Kerala",    country:"India", image:holidayKeralaImg,   tagline:"God's Own Country" },
  { name:"Himachal",  country:"India", image:holidayHimachalImg, tagline:"Mountains & Monasteries" },
  { name:"Rajasthan", country:"India", image:holidayGujratImg,   tagline:"Land of Kings" },
  { name:"Andaman",   country:"India", image:holidayAndamanImg,  tagline:"Island Paradise" },
  { name:"Sikkim",    country:"India", image:holidayNorthEastImg,tagline:"Himalayan Gem" },
];

const TRENDING_DESTINATIONS = [
  { name: "Andaman", image: holidayAndamanImg, duration: "4 Nights / 5 Days", layout: "wide-top" },
  { name: "Thailand", image: holidayThailandImg, duration: "5 Nights / 6 Days", layout: "tall-center" },
  { name: "Vietnam", image: singaporeImg, duration: "5 Nights / 6 Days", layout: "wide-top" },
  { name: "Manali", image: holidayManaliImg, duration: "3 Nights / 4 Days", layout: "small" },
  { name: "Gujarat", image: holidayGujratImg, duration: "4 Nights / 5 Days", layout: "small" },
  { name: "Malaysia", image: lumpurImg, duration: "3 Nights / 4 Days", layout: "wide-bottom" },
];

const CATEGORY_SHOWCASE = [
  { name: "Beach", title: "Beach Holiday", before: "Sun,", highlight: "sand", after: "and sea escapes", image: holidayBeachEscapeImg },
  { name: "Adventure", title: "Adventure Trip", before: "Thrills,", highlight: "trails", after: "and wild escapes", image: holidayManaliImg },
  { name: "Cultural", title: "Cultural Tour", before: "Heritage,", highlight: "temples", after: "and stories", image: holidayGujratImg },
  { name: "Honeymoon", title: "Honeymoon Escape", before: "Romance,", highlight: "love", after: "and quiet stays", image: holidayGoaImg },
  { name: "Family", title: "Family Vacation", before: "Easy,", highlight: "happy", after: "and shared moments", image: holidayKeralaImg },
  { name: "Wildlife", title: "Wildlife Safari", before: "Forests,", highlight: "nature", after: "and discovery", image: holidayAndamanImg },
];

const HERO_SLIDES = [
  heroSlide1,
  heroSlide2,
  heroSlide3,
  heroSlide4,
];

const HERO_CATEGORIES = [
  { label: "Easy Book", badge: "NEW", image: holidayGujratImg },
  { label: "Honeymoon", image: holidayGoaImg },
  { label: "Pilgrimage", image: holidayGujratImg },
  { label: "Luxury", image: holidayParisImg },
  { label: "Adventure", image: holidayManaliImg },
];

const fmt = p =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(p);

const parseArrayField = (value) => {
  if (Array.isArray(value)) return value;
  if (!value) return [];

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return value
        .split(",")
        .map(item => item.trim())
        .filter(Boolean);
    }
  }

  return [];
};

const slugify = value => String(value || "")
  .trim()
  .toLowerCase()
  .replace(/&/g, "and")
  .replace(/[^a-z0-9]+/g, "-")
  .replace(/^-+|-+$/g, "");

  const getNights = duration => {
  const match = String(duration || "").match(/(\d+)\s*Night/i);
  return match ? Number(match[1]) : 0;
};

/* ── Stars ── */
function Stars({ rating, size = 13 }) {
  return (
    <span className="stars">
      {[1,2,3,4,5].map(i => (
        <span key={i} style={{ color: i <= Math.round(rating) ? "#f59e0b" : "#dceee4", fontSize: size }}>★</span>
      ))}
    </span>
  );
}

/* ── Navbar ── */
// eslint-disable-next-line no-unused-vars
function Navbar({ page, onNav }) {
  const [scrolled, setScrolled]     = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  const links = [
    { id:"home",         label:"Holidays"     },
    { id:"destinations", label:"Destinations" },
    { id:"about",        label:"About Us"     },
  ];
  const go = p => { onNav(p); setMobileOpen(false); };

  return (
    <>
      <nav className={`nav${scrolled ? " nav--scrolled" : ""}`}>
        <div className="nav-inner">
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ width:38, height:38, background:"linear-gradient(135deg,#2e8b57,#4db882)", borderRadius:10, display:"flex", alignItems:"center", justifyContent:"center", fontSize:20 }}>🐝</div>
            <span style={{ fontFamily:"'Playfair Display',serif", fontWeight:800, fontSize:"1.15rem", color:"#0d3d2c" }}>MakeBeeTrip</span>
          </div>
          <div className="nav-links">
            {links.map(l => (
              <button key={l.id} className={`nav-link${page === l.id ? " nav-link--active" : ""}`} onClick={() => go(l.id)}>
                {l.label}
              </button>
            ))}
            <button className="nav-cta" onClick={() => go("contact")}><MessageCircle size={16} /> Get a Quote</button>
          </div>
          <button className="nav-hamburger" onClick={() => setMobileOpen(v => !v)} aria-label="Menu">
            <span style={{ transform: mobileOpen ? "rotate(45deg) translate(4px,4px)" : "" }} />
            <span style={{ opacity: mobileOpen ? 0 : 1 }} />
            <span style={{ transform: mobileOpen ? "rotate(-45deg) translate(4px,-4px)" : "" }} />
          </button>
        </div>
      </nav>
      <div className={`nav-mobile${mobileOpen ? " open" : ""}`}>
        {links.map(l => (
          <button key={l.id} className={`nav-mobile-link${page === l.id ? " nav-mobile-link--active" : ""}`} onClick={() => go(l.id)}>
            {l.label}
          </button>
        ))}
        <button className="nav-mobile-cta" onClick={() => go("contact")}><MessageCircle size={16} /> Get a Free Quote <ArrowRight size={16} /></button>
      </div>
    </>
  );
}

/* ── Package Card ── */
function PkgCard({ pkg, onOpenPackages, index }) {
  const [wishlisted, setWishlisted] = useState(false);
  const shownFacilities = pkg.facilities.slice(0, 4);
  const extra           = pkg.facilities.length - 4;
  const openPackagePage = () => onOpenPackages(pkg.location || pkg.title);

  return (
    <article
      className="pkg-card anim-fadeup"
      style={{ animationDelay: `${index * 0.06}s` }}
      role="button"
      tabIndex={0}
      onClick={openPackagePage}
      onKeyDown={e => {
        if (e.key !== "Enter" && e.key !== " ") return;
        e.preventDefault();
        openPackagePage();
      }}
    >
      <div className="pkg-card-img-wrap">
        <img
  className="pkg-card-img"
  src={pkg.image_url}
  alt={pkg.title}
  loading="lazy"
/>
        <div className="pkg-card-img-overlay" />
        {pkg.badge && (
  <span className={`pkg-card-badge badge-${pkg.badge_type || ""}`}>
    {pkg.badge}
  </span>
)}
        <button
          className={`pkg-card-wish${wishlisted ? " pkg-card-wish--active" : ""}`}
          onClick={e => { e.stopPropagation(); setWishlisted(v => !v); }}
          aria-label="Wishlist"
        >
          {wishlisted ? "♥" : "♡"}
        </button>
        {Number(pkg.discount_percent) > 0 && (
  <span className="pkg-card-discount">
    {Number(pkg.discount_percent)}% OFF
  </span>
)}
      </div>
      <div className="pkg-card-body">
        <p className="pkg-card-loc">📍 {pkg.location}</p>

        <h3 className="pkg-card-title">{pkg.title}</h3>
        <div className="pkg-card-meta">
          <Clock3 size={14} />
          <span>{pkg.duration}</span>
          <span className="pkg-card-meta-sep" />
          <Users size={14} />
          <span>{pkg.group_size} pax</span>
        </div>
        <div className="pkg-card-rating">
          <Stars rating={pkg.rating} />
          <span className="pkg-card-rating-val">{pkg.rating.toFixed(1)}</span>
          <span className="pkg-card-rating-count">({pkg.reviews.toLocaleString("en-IN")} reviews)</span>
        </div>
        <div className="pkg-card-tags">
          {shownFacilities.map(f => (
            <span key={f.name} className="pkg-card-tag">{f.name}</span>
          ))}
          {extra > 0 && <span className="pkg-card-tag pkg-card-tag-more">+{extra} more</span>}
        </div>
        <div className="pkg-card-divider" />
        <div className="pkg-card-footer">
          <div>
            <p className="pkg-card-price-label">From</p>
            <div className="pkg-card-price-row">
  {Number(pkg.base_price) > Number(pkg.final_price) && (
    <span className="pkg-card-old">{fmt(pkg.base_price)}</span>
  )}

  <span className="pkg-card-new">
    {fmt(pkg.final_price)}
  </span>
</div>

<p className="pkg-card-per">
  {pkg.pricing_basis === "per_room"
    ? "per room · all-inclusive"
    : pkg.pricing_basis === "per_booking"
      ? "per booking · all-inclusive"
      : "per person · all-inclusive"}
</p>
          </div>

          <button className="pkg-card-btn" onClick={e => { e.stopPropagation(); openPackagePage(); }}>Explore <ArrowRight size={15} /></button>
        </div>
      </div>
    </article>
  );
}

/* ── Holidays Home Page ── */

function HolidaysPage({ onView, onNav, onEvent, onOpenPackages }) {
  const [searchParams] = useSearchParams();

  const queryParams = useMemo(
    () => new URLSearchParams(searchParams.toString()),
    [searchParams]
  );

  const [cat,     setCat]     = useState("all");
const [search, setSearch] = useState(
  () => queryParams.get("dest") || ""
);
const [destinationOpen, setDestinationOpen] = useState(false);
  const [sort,    setSort]    = useState("popular");
  const [visible, setVisible] = useState(9);
  const [heroSlide, setHeroSlide] = useState(0);
  const [city,    setCity]    = useState("all");

  const [packageType, setPackageType] = useState("domestic");
  const [packages, setPackages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [reloadKey, setReloadKey] = useState(0);

  const packageScrollRef = useRef(null);

  useEffect(() => {
    let alive = true;

    async function loadPackages() {
      setLoading(true);
      setError("");
      try {
        const [pkgRes, catRes] = await Promise.all([
  fetch(`${API_BASE}/packages`),
  fetch(`${API_BASE}/packages/categories`),
]);

        if (!pkgRes.ok) throw new Error(`Packages ${pkgRes.status}`);
        if (!catRes.ok) throw new Error(`Categories ${catRes.status}`);

        const [pkgData, catData] = await Promise.all([pkgRes.json(), catRes.json()]);
        if (!alive) return;

        setPackages(Array.isArray(pkgData) ? pkgData : pkgData.data || []);
        setCategories((Array.isArray(catData) ? catData : catData.data || []).map(c => ({
          ...c,
          Icon: ICONS[c.icon] || Globe,
        })));
      } catch (err) {
        if (alive) setError("Unable to load holiday packages. Please check your connection and try again.");
      } finally {
        if (alive) setLoading(false);
      }
    }

    loadPackages();
    return () => { alive = false; };
  }, [reloadKey, queryParams]);

  const retryLoad = () => setReloadKey(k => k + 1);

  useEffect(() => {
    const timer = setInterval(() => {
      setHeroSlide(current => (current + 1) % HERO_SLIDES.length);
    }, 4500);

    return () => clearInterval(timer);
  }, []);

  // City options come from unique `location` values of loaded active packages
  const cityOptions = useMemo(() => {
  return [...new Set(
    packages
      .filter(p => p.is_active == null || Number(p.is_active) === 1)
      .map(p => String(p.location || "").trim())
      .filter(Boolean)
  )].sort((a, b) => a.localeCompare(b));
}, [packages]);


const matchingPackages = useMemo(() => {
  const term = search.trim().toLowerCase();

  const activePackages = packages.filter(
    p =>
      p.is_active == null ||
      Number(p.is_active) === 1 ||
      p.is_active === true
  );

  if (!term) return activePackages;

  const words = term.split(/\s+/).filter(Boolean);

  // Allow small spelling mistakes, e.g. "Uddepy" for "Udaipur".
  const isCloseMatch = (word, text) => {
    if (text.includes(word)) return true;
    if (word.length < 5) return false;

    const maxDistance = word.length >= 7 ? 2 : 1;
    let previous = Array.from(
      { length: text.length + 1 },
      (_, i) => i
    );

    for (let i = 1; i <= word.length; i++) {
      const current = [i];
      let rowMin = i;

      for (let j = 1; j <= text.length; j++) {
        current[j] = Math.min(
          current[j - 1] + 1,
          previous[j] + 1,
          previous[j - 1] + (word[i - 1] === text[j - 1] ? 0 : 1)
        );
        rowMin = Math.min(rowMin, current[j]);
      }

      if (rowMin > maxDistance) return false;
      previous = current;
    }

    return previous[text.length] <= maxDistance;
  };

  return activePackages
    .map(pkg => {
      const title = String(pkg.title || "").toLowerCase();
      const location = String(pkg.location || "").toLowerCase();
      const category = String(
        pkg.category_label || pkg.category_name || pkg.category || ""
      ).toLowerCase();

      const titleWords = title.split(/[\s,/-]+/).filter(Boolean);
      const locationWords = location.split(/[\s,/-]+/).filter(Boolean);
      const searchableText = `${title} ${location} ${category}`;

      const matchedWords = words.filter(word =>
        isCloseMatch(word, searchableText)
      ).length;

      const score = words.reduce((total, word) => {
        if (titleWords.some(w => w === word)) return total + 10;
        if (locationWords.some(w => w === word)) return total + 8;
        if (titleWords.some(w => isCloseMatch(word, w))) return total + 6;
        if (locationWords.some(w => isCloseMatch(word, w))) return total + 5;
        if (isCloseMatch(word, searchableText)) return total + 2;
        return total;
      }, 0);

      return { pkg, score, matchedWords };
    })
    .filter(item => item.matchedWords > 0)
    .sort(
      (a, b) =>
        b.matchedWords - a.matchedWords ||
        b.score - a.score ||
        String(a.pkg.title || "").localeCompare(String(b.pkg.title || ""))
    )
    .map(item => item.pkg);
}, [packages, search]);

useEffect(() => {
  const destination = queryParams.get("dest") || "";
  setSearch(destination);
  setCity("all");
}, [queryParams]);



const filtered = matchingPackages
  .filter(p =>
    cat === "all" || String(p.category_id) === String(cat)
  )
  .filter(p =>
    city === "all" ||
    String(p.location || "").trim() === city
  )
  .sort((a, b) =>
    sort === "price_asc"
      ? Number(a.final_price || 0) - Number(b.final_price || 0)
      : sort === "price_desc"
        ? Number(b.final_price || 0) - Number(a.final_price || 0)
        : sort === "duration"
          ? Number(a.duration_days || 0) - Number(b.duration_days || 0)
          : Number(b.rating || 0) - Number(a.rating || 0)
  );


  const [queryFilter, setQueryFilter] = useState({});

  useEffect(() => {
    const params = {};
    const dest = queryParams.get("dest");
    const month = queryParams.get("month");
    const type = queryParams.get("type");
    const nights = queryParams.get("nights");
    const hasQueryFilters = dest || month || type || nights;

    if (hasQueryFilters) {
      if (dest) params.dest = dest;
      if (month) params.month = month;
      if (type) params.type = type;
      if (nights) params.nights = nights;
    }

    setQueryFilter(params);
  }, [queryParams]);

  const filteredByQuery = useMemo(() => {
    if (Object.keys(queryFilter).length === 0) return filtered;

    return filtered.filter((pkg) => {
      if (queryFilter.dest && !String(pkg.location || "").toLowerCase().includes(queryFilter.dest.toLowerCase()) &&
          !String(pkg.title || "").toLowerCase().includes(queryFilter.dest.toLowerCase())) {
        return false;
      }
      if (queryFilter.type) {
  const selectedCategory = categories.find(
    (category) =>
      String(category.label || category.name || "")
        .trim()
        .toLowerCase() === queryFilter.type.trim().toLowerCase()
  );

  const packageCategory = String(
    pkg.category_label || pkg.category_name || pkg.category || ""
  ).trim().toLowerCase();

  if (
    selectedCategory &&
    String(pkg.category_id) !== String(selectedCategory.id)
  ) {
    return false;
  }

  if (
    !selectedCategory &&
    packageCategory &&
    packageCategory !== queryFilter.type.trim().toLowerCase()
  ) {
    return false;
  }
}
      if (queryFilter.nights) {
        const nights = Number(queryFilter.nights);
        const pkgNights = Number(String(pkg.duration_days || "").trim()) || getNights(pkg.duration);
        if (pkgNights > nights) return false;
      }
      return true;
    });
  }, [queryFilter, filtered]);

 const activeFilteredPackages = filtered;

const shown = activeFilteredPackages.slice(0, visible);
const hasMore = visible < activeFilteredPackages.length;
  const topPick = packages.find(p => p.badge_type === "top" || p.badge_type === "bestseller") || packages[0];

  const internationalWords = ["bali", "dubai", "singapore", "vietnam", "europe", "thailand", "maldives", "paris", "london"];
  const typedPackages = filtered.filter(p => {
    const haystack = `${p.title || ""} ${p.location || ""}`.toLowerCase();
    const isInternational = internationalWords.some(word => haystack.includes(word));
    return packageType === "international" ? isInternational : !isInternational;
  });
  const handpickedPackages = (typedPackages.length ? typedPackages : filtered).slice(0, Math.max(visible, 9));
  const scrollPackages = direction => {
    packageScrollRef.current?.scrollBy({ left: direction * 580, behavior: "smooth" });
  };

  const WHY_ITEMS = [
    { Icon: BadgePercent, title:"Best Price Guarantee",   desc:"We match any lower price you find within 24 hours. You will always pay the best rate."            },
    { Icon: ShieldCheck,  title:"Secure & Verified",      desc:"100% secure checkout. Every supplier is vetted for safety and quality before listing."            },
    { Icon: Sparkles,     title:"Fully Customizable",     desc:"Every package tailored to your travel dates, budget, group size and personal preferences."        },
    { Icon: Headset,      title:"24 × 7 Support",         desc:"Our travel experts are always reachable by phone, WhatsApp or email, day or night."               },
    { Icon: Plane,        title:"Flight + Hotel Combos",  desc:"Bundle flights and hotels to save up to 30% versus booking each separately."                      },
    { Icon: Star,         title:"Trusted by 12,000+",     desc:"Thousands of happy travellers have explored India's finest destinations with us."                  },
  ];


  const BENEFITS_ITEMS = [
    { icon: "🏖️", title: "Customised Itineraries", desc: "Enjoy our bespoke tour packages that can be tailored according to your preferences for personalised experience." },
    { icon: "₹⬇️", title: "Wallet-Friendly Prices", desc: "Every traveller from worldwide can embark on unforgettable journeys with our unbeatable holiday package prices." },
    { icon: "🔥", title: "Exciting Deals", desc: "Our platform comprises perfect deals and discounts on all exclusive holiday packages to ensure value-for-money." },
    { icon: "👩‍💻", title: "24/7 Support", desc: "Our customer support team is always available to assist you and resolve travel-related queries instantly." },
  ];

  return (
    <div className="holidays-page">
      {/* ── Hero ── */}
      <section className="hero holidays-hero">
        <div className="hero-bg">
          <img className="hero-img" src={HERO_SLIDES[heroSlide]} alt="" />
          <div className="hero-overlay" />
          <div className="hero-dots" />
          <div className="hero-blob hero-blob--1" />
          <div className="hero-blob hero-blob--2" />
        </div>
        <button type="button" className="hero-quote-btn" onClick={() => onNav("contact")}>
          <MessageCircle size={16} />
          Get a Quote
        </button>
        <div className="hero-inner">

          <div className="holidays-hero-content">
            <div className="anim-fadeup">
              <div className="hero-badge">
                <span className="hero-badge-dot" />India's Most Loved Travel Brand
              </div>
            </div>

            <p className="holidays-hero-script">Australia Tour Packages</p>
            <h1 className="hero-title anim-fadeup anim-d1">
              Where Every Experience Counts!
            </h1>
            <p className="hero-sub anim-fadeup anim-d2">
              Curated tours across beaches, mountains, heritage trails and beyond — with flights,
              stays, meals and transfers seamlessly arranged for you.
            </p>

<div className="hero-search anim-fadeup anim-d3">
  <span className="hero-search-icon">
    <Search size={18} />
  </span>

  <input
    className="hero-search-input"
    placeholder="Enter Your Dream Destination!"
    value={search}
    autoComplete="off"
    onFocus={() => setDestinationOpen(true)}
    onChange={(e) => {
      setSearch(e.target.value);
      setCity("all");
      setDestinationOpen(true);
    }}
  />

{destinationOpen && (
  <div className="holiday-destination-suggestions">
    {matchingPackages.length > 0 ? (
      matchingPackages.map(pkg => (
        <button
          type="button"
          key={pkg.id}
          onMouseDown={e => {
            e.preventDefault();
            setSearch(pkg.location || pkg.title);
            setCity("all");
            setDestinationOpen(false);
            setVisible(9);
          }}
        >
          <MapPin size={16} />
          <span>
            <strong>{pkg.location}</strong>
            <small>{pkg.title}</small>
          </span>
        </button>
      ))
    ) : (
      <p className="holiday-no-suggestions">
        {search.trim()
          ? "No matching packages found."
          : "Start typing a destination."}
      </p>
    )}
  </div>
)}

  <button
    className="hero-search-btn"
    type="button"
    onClick={() => {
  setCat("all");
  setCity("all");
  setDestinationOpen(false);
  setVisible(9);

  document.querySelector(".pkg-section")
    ?.scrollIntoView({ behavior: "smooth", block: "start" });
}}
  >
    <Search size={16} /> Search
  </button>
</div>
            <div className="holidays-hero-cats anim-fadeup anim-d4">
              {HERO_CATEGORIES.map(item => (
                <div key={item.label} className="holidays-hero-cat">
                  <span className="holidays-hero-cat-img">
                    <img src={item.image} alt="" />
                  </span>
                  <span className="holidays-hero-cat-text">
                    {item.badge && <span className="holidays-hero-cat-badge">{item.badge}</span>}
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
            <div className="hero-stats anim-fadeup anim-d4">
              {[{v:"50+",l:"Destinations"},{v:"12K+",l:"Happy Travelers"},{v:"4.8★",l:"Avg Rating"},{v:"100%",l:"Trusted Service"}].map(s => (
                <div key={s.l} className="hero-stat">
                  <span className="hero-stat-val">{s.v}</span>
                  <span className="hero-stat-label">{s.l}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Floating card */}
          {topPick && <div className="hero-card anim-fadeup anim-d2">
            <div className="hero-card-img">
              <img src={topPick.image_url} alt={topPick.title} />
              <div className="hero-card-img-overlay" />
              <span className="hero-card-badge"><Trophy size={12} /> Top Pick This Season</span>
            </div>
            <div className="hero-card-body">
              <p className="hero-card-loc">{topPick.location}</p>
              <h4 className="hero-card-title">{topPick.title}</h4>
              <div className="hero-card-meta">
                <span className="hero-card-price">
  {fmt(topPick.final_price)}
  <span>
    {topPick.pricing_basis === "per_room"
      ? "/room"
      : topPick.pricing_basis === "per_booking"
        ? "/booking"
        : "/pax"}
  </span>
</span>
                <div className="hero-card-stars">
                  <Stars rating={topPick.rating} size={13} />
                  <span style={{ fontSize:".78rem", color:"#5a6e61", marginLeft:4 }}>{topPick.rating.toFixed(1)}</span>
                </div>
              </div>
            </div>
          </div>}
        </div>
      </section>

      <div className="cat-strip">
        <div className="cat-strip-inner">
          <div className="cat-scroll">
            {categories.map(c => (
              <button
                key={c.id}
                className={`cat-btn${cat === c.id ? " cat-btn--active" : ""}`}
                onClick={() => { setCat(c.id); setVisible(9); }}
              >
                <span className="cat-btn-icon"><c.Icon size={15} strokeWidth={2} /></span>
                {c.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ── Package grid ── */}
      <section className="pkg-section">
        <div className="pkg-section-inner">
          <div className="pkg-toolbar">
            <div className="pkg-toolbar-title">
              <span className="pkg-toolbar-icon"><Palmtree size={16} /></span>
              <div>

                <h2>Handpicked Holiday Packages</h2>
                <p className="pkg-count">
                  Indulge in unforgettable adventure with special tour plans.
                </p>
              </div>
            </div>
            <div className="pkg-sort">
              <label>City</label>
              <select value={city} onChange={e => { setCity(e.target.value); setVisible(9); }}>
                <option value="all">All Cities</option>
                {cityOptions.map(c => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
            </div>
            <div className="pkg-sort">
              <label>Sort by</label>
              <select value={sort} onChange={e => setSort(e.target.value)}>
                <option value="popular">Most Popular</option>
                <option value="price_asc">Price: Low → High</option>
                <option value="price_desc">Price: High → Low</option>
                <option value="duration">Duration</option>
              </select>
            </div>
          </div>


          <div className="handpicked-tabs">
            {["domestic", "international"].map(type => (
              <div
                key={type}
                role="button"
                tabIndex={0}
                className={`handpicked-tab${packageType === type ? " handpicked-tab--active" : ""}`}
                onClick={() => {
                  setPackageType(type);
                  packageScrollRef.current?.scrollTo({ left: 0, behavior: "smooth" });
                }}
                onKeyDown={e => {
                  if (e.key !== "Enter" && e.key !== " ") return;
                  e.preventDefault();
                  setPackageType(type);
                  packageScrollRef.current?.scrollTo({ left: 0, behavior: "smooth" });
                }}
              >
                {type === "domestic" ? "Domestic" : "International"}
              </div>
            ))}
          </div>

          {loading ? (
            <div className="pkg-empty">
              <span className="pkg-empty-emoji">...</span>
              <h3>Loading packages</h3>
              <p>Fetching the latest holidays from the database.</p>
            </div>
          ) : error ? (
            <div className="pkg-empty">
              <span className="pkg-empty-emoji">⚠️</span>
              <h3>Unable to load packages</h3>
              <p>{error}</p>
              <button className="pkg-empty-btn" onClick={retryLoad}>
                <ArrowRight size={16} style={{ transform: "rotate(-90deg)" }} />
                Retry
              </button>
            </div>
          ) : filtered.length === 0 ? (
            <div className="pkg-empty">
              <span className="pkg-empty-emoji">🔍</span>
              <h3>No packages found</h3>
              <p>Try a different search or category.</p>
              <button className="pkg-empty-btn" onClick={() => { setSearch(""); setCat("all"); setCity("all"); }}>
                <Eraser size={16} />
                Clear Filters
              </button>
              <button type="button" className="pkg-empty-link" onClick={() => onNav("contact")}>
                <Headset size={16} />
                Contact Support
              </button>
            </div>
          ) : (
            <>

              <div className="handpicked-scroll-wrap">
                <button type="button" className="handpicked-arrow handpicked-arrow--left" onClick={() => scrollPackages(-1)} aria-label="Scroll packages left">
                  <ArrowLeft size={20} />
                </button>
                <div className="pkg-grid handpicked-scroll" ref={packageScrollRef}>
                  {activeFilteredPackages.slice(0, Math.max(visible, 9)).map((p, i) => (
                    <PkgCard key={p.id} pkg={p} index={i} onOpenPackages={onOpenPackages} />
                  ))}
                </div>
                <button type="button" className="handpicked-arrow handpicked-arrow--right" onClick={() => scrollPackages(1)} aria-label="Scroll packages right">
                  <ArrowRight size={20} />
                </button>
              </div>
              {hasMore && (
                <div className="load-more-wrap">
                  <button className="load-more-btn" onClick={() => setVisible(v => v + 6)}>
                    Load More Packages <ArrowDown size={16} />
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </section>

      {/* ── CTA Banner ── */}

      <section className="cta-section">
        <div className="cta-inner">
          <div>
            <p className="cta-eyebrow">Custom Packages</p>
            <h2 className="cta-title">Can't find what you're looking for?</h2>
            <p className="cta-sub">
              Tell us your dream destination, travel dates and budget — we'll craft a bespoke
              itinerary just for you, at no extra cost.
            </p>
            {loading && (
              <p style={{ color:"rgba(255,255,255,.6)", fontSize:".75rem", marginTop:8 }}>
                Refreshing latest package data...
              </p>
            )}
          </div>
          <button className="cta-btn" onClick={() => onNav("contact")}>
            Request Custom Package →
          </button>
        </div>
      </section>

      <section className="holiday-booking-info-section">
        <div className="holiday-booking-info-inner">
          <h2>Book Your Holiday With MakeBeeTrip</h2>
          <p>
            Book Your Holiday Packages With EaseMyTrip and discover a world of meticulously curated, affordable itineraries
            designed to meet the unique needs and budgets of every traveller. Each getaway is crafted with precision,
            ensuring that every aspect of your journey is seamless and memorable. Whether you're seeking adventure,
            relaxation, or a blend of both, our packages promise an unforgettable getaway tailored just for you.
            Start planning your dream vacation today and experience the perfect escape with our exceptional itineraries.
          </p>

          <h3>Enjoy Seamless Booking At Budget-Friendly Prices!</h3>
          <p>
            Our platform's user-friendly interface simplifies the navigation of diverse trip packages, catering to various
            destinations, preferences, and budgets. With just a few clicks, travellers can book their ideal vacation.
            Whether you're dreaming of a beach escape or a mountain retreat, finding and booking your perfect getaway is
            straightforward and hassle-free with us, ensuring a smooth start to your travel adventure.
          </p>
          <p>
            Unlock unbeatable savings on your next getaway with us, your ultimate travel companion! Discover a world of
            affordable packages customised to meet the diverse needs of every traveller. Embark on a mountain escape or a
            city adventure with our exclusive travel at competitive prices and leverage exclusive discounts, ensuring your
            travel is as economical as it is enjoyable.
          </p>

          <h3>Create Memories That Last A Lifetime!</h3>
          <p>
            Book and explore your dream destinations with our exclusive itineraries. Each of our packages are carefully
            designed to ensure that every traveller enjoy a promising getaway. Whether you're a solo traveller, part of a
            group, or travelling with family, we have tailored itineraries to suit everyone. Choose from a wide range of
            splendid tour packages and let us handle the details, guaranteeing a seamless and memorable experience.
            Start your adventure with EaseMyTrip and cherish every moment of your journey.
          </p>
        </div>
      </section>
    </div>
  );
}

/* ── Package Detail Page ── */
function DetailPage({ pkg, onBack }) {
  const [tab,    setTab]    = useState("itinerary");
  const [detailPkg, setDetailPkg] = useState(null);
const [loading, setLoading] = useState(true);
const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let alive = true;

    async function loadPackage() {
      setLoading(true);
      setNotFound(false);
      try {
        const res = await fetch(`${API_BASE}/packages/${pkg.id}`);
        if (!res.ok) throw new Error(`Package ${res.status}`);
        const data = await res.json();
        if (alive) setDetailPkg(data.data || data);
      } catch {
  if (alive) setNotFound(true);
} finally {
        if (alive) setLoading(false);
      }
    }

    loadPackage();
    return () => { alive = false; };
  }, [pkg]);

  const currentPkg = detailPkg
  ? {
      ...detailPkg,

      category:
        detailPkg.category_label ||
        detailPkg.category_name ||
        detailPkg.category ||
        detailPkg.category_id ||
        "Holiday Package",

      rating: Number(detailPkg.rating || 0),
      reviews: Number(detailPkg.reviews || 0),

      group_size:
        detailPkg.group_size ||
        detailPkg.groupSize ||
        "Not specified",

      highlights: parseArrayField(detailPkg.highlights),

      facilities: parseArrayField(detailPkg.facilities),

      inclusions: parseArrayField(detailPkg.inclusions),

      exclusions: parseArrayField(detailPkg.exclusions),

      itinerary: parseArrayField(detailPkg.itinerary),

      final_price:
        detailPkg.final_price !== null &&
        detailPkg.final_price !== undefined
          ? Number(detailPkg.final_price)
          : 0,

      base_price:
        detailPkg.base_price !== null &&
        detailPkg.base_price !== undefined
          ? Number(detailPkg.base_price)
          : 0,

      discount_amount: Number(detailPkg.discount_amount || 0),
    }
  : null;

  if (notFound) {
    return (
      <div style={{ background:"#f8fbf9", minHeight:"100vh" }}>
        <div className="pkg-empty">
          <span className="pkg-empty-emoji">🔍</span>
          <h3>Package unavailable</h3>
          <p>This holiday package is no longer available.</p>
          <button className="pkg-empty-btn" onClick={onBack}>
            <ArrowLeft size={16} />
            Back to packages
          </button>
        </div>
      </div>
    );
  }

  if (loading && !currentPkg) {
    return (
      <div style={{ background:"#f8fbf9", minHeight:"100vh" }}>
        <div className="pkg-empty">
          <span className="pkg-empty-emoji">...</span>
          <h3>Loading package</h3>
          <p>Fetching the latest details from the database.</p>
        </div>
      </div>
    );
  }

  const TABS = [
    { id:"itinerary",  label:"Itinerary" },
    { id:"inclusions", label:"Included"  },
    { id:"exclusions", label:"Excluded"  },
  ];

  return (
    <div style={{ background:"#f8fbf9", minHeight:"100vh" }}>
      {/* Hero */}
      <div className="detail-hero">
        <img
  className="detail-hero-img"
  src={currentPkg.image_url}
  alt={currentPkg.title}
/>
        <div className="detail-hero-overlay" />
        <button className="detail-hero-back" onClick={onBack}>← Back to packages</button>
        <div className="detail-hero-content">
          <div style={{ maxWidth:1100, margin:"0 auto" }}>
            <span className={`pkg-card-badge badge-${currentPkg.badge_type}`} style={{ marginBottom:10, display:"inline-block" }}>
              {currentPkg.badge}
            </span>
            <h1 style={{ fontFamily:"'Playfair Display',serif", color:"#fff", fontWeight:800, fontSize:"clamp(1.6rem,3.5vw,2.6rem)", letterSpacing:"-.03em", margin:"8px 0", lineHeight:1.1 }}>
              {currentPkg.title}
            </h1>
            <p style={{ color:"rgba(255,255,255,.75)", fontSize:".95rem" }}>
              📍 {currentPkg.location} &nbsp;·&nbsp; {currentPkg.duration} &nbsp;·&nbsp; 👥 {currentPkg.group_size} pax
            </p>
          </div>
        </div>
      </div>

      {/* Stats row */}
      <div style={{ maxWidth:1100, margin:"0 auto", padding:"32px 24px 0" }}>
        <div className="detail-stats">
  {[
    {
      icon: <Landmark size={18} />,
      val: currentPkg.category,
      label: "Category"
    },
    {
      icon: <Star size={18} />,
      val: `${currentPkg.rating.toFixed(1)} (${currentPkg.reviews.toLocaleString("en-IN")})`,
      label: "Rating"
    },
    {
      icon: <Clock3 size={16} />,
      val: currentPkg.duration,
      label: "Duration"
    },
    {
      icon: <Users size={18} />,
      val: `${currentPkg.group_size} pax`,
      label: "Group Size"
    },
  ].map(s => (
            <div key={s.label} className="detail-stat">
              <span className="detail-stat-icon">{s.icon}</span>
              <span className="detail-stat-val">{s.val}</span>
              <span className="detail-stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="detail-inner">
        {/* Left column */}
        <div>
          <p className="detail-desc">{currentPkg.description}</p>

          {currentPkg.highlights.length > 0 && (
  <>
    <h3 className="detail-section-title">Tour Highlights</h3>

    <div className="detail-tags">
      {currentPkg.highlights.map((highlight, index) => (
        <span
          key={`${highlight}-${index}`}
          className="detail-tag"
        >
          ✓ {highlight}
        </span>
      ))}
    </div>
  </>
)}

          <h3 className="detail-section-title">Facilities & Amenities</h3>
          <div className="detail-facilities">
            {(currentPkg.facilities || []).map(f => (
              <span key={f.name} className="detail-facility">{f.name}</span>
            ))}
          </div>

          {/* Tabs */}
          <div className="detail-tabs">
            {TABS.map(t => (
              <button
                key={t.id}
                className={`detail-tab${tab === t.id ? " detail-tab--active" : ""}`}
                onClick={() => setTab(t.id)}
              >
                {t.label}
              </button>
            ))}
          </div>

          {tab === "itinerary" && (
            <div className="detail-itinerary">
  {currentPkg.itinerary.map((day, index) => {
    const dayNumber = day.day ?? index + 1;
    const title = day.title || `Day ${dayNumber}`;
    const description = day.description || day.desc || "";

    return (
      <div
        key={`${dayNumber}-${title}-${index}`}
        className="detail-day"
      >
        <div className="detail-day-num">
          {String(dayNumber).padStart(2, "0")}
        </div>

        <div>
          <p className="detail-day-title">
            {title}
          </p>

          {description && (
            <p className="detail-day-desc">
              {description}
            </p>
          )}

          {Array.isArray(day.points) && day.points.length > 0 && (
            <ul style={{
              marginTop: 8,
              paddingLeft: 18,
              color: "#5a6e61",
              fontSize: ".84rem",
              lineHeight: 1.6
            }}>
              {day.points.map((point, pointIndex) => (
                <li key={`${point}-${pointIndex}`}>
                  {point}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    );
  })}
</div>
          )}

          {(tab === "inclusions" || tab === "exclusions") && (
            <ul className="detail-list">
              {(tab === "inclusions" ? currentPkg.inclusions || [] : currentPkg.exclusions || []).map(item => (
                <li key={item} className="detail-list-item">
                  <span className="detail-list-dot" style={{ background: tab === "inclusions" ? "#2e8b57" : "#e55a4e" }} />
                  {item}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Right — price card */}
        <div>
          <div className="price-card">
            <p className="price-card-label">Package Price</p>

<div className="price-card-row">
  {Number(currentPkg.base_price) > Number(currentPkg.final_price) && (
    <span className="price-card-old">
      {fmt(currentPkg.base_price)}
    </span>
  )}

  <span className="price-card-new">
    {fmt(currentPkg.final_price)}
  </span>
</div>

<p className="price-card-per">
  {currentPkg.pricing_basis === "per_room"
    ? "per room · taxes inclusive"
    : currentPkg.pricing_basis === "per_booking"
      ? "per booking · taxes inclusive"
      : "per person · taxes inclusive"}
</p>

{Number(currentPkg.discount_amount) > 0 && (
  <div className="price-card-save">
    <BadgePercent size={14} />
    Save {fmt(currentPkg.discount_amount)}
    {currentPkg.pricing_basis === "per_person"
      ? " per person"
      : ""}
  </div>
)}
            <button
  className="price-card-book"
  type="button"
  onClick={() => {
    const placeSlug = String(currentPkg.location || "")
      .trim()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

    const packageSlug = String(currentPkg.title || "")
      .trim()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

    window.location.href = `/holidays/booking/${placeSlug}/${packageSlug}`;
  }}
>
  Book This Package →
</button>
            <button className="price-card-callback">
              <Phone size={15} /> Request a Callback
            </button>
            <div className="price-card-trust">
              {["Best Price Guarantee","Free Itinerary Changes","24/7 Travel Support","Secure Payment"].map(t => (
                <div key={t} className="price-card-trust-item">
                  <span style={{ color:"#2e8b57", fontWeight:700 }}>✓</span> {t}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ── Destinations Page ── */
function DestinationsPage({ onBack, onNav, onOpenPackages }) {
  const WHY_DEST = [
    { Icon: Trophy,      t:"Best Prices",   d:"Price-match guarantee"       },
    { Icon: ShieldCheck, t:"Safe Travel",   d:"Vetted suppliers & insurance" },
    { Icon: Target,      t:"Curated Trips", d:"Handpicked by local experts"  },
    { Icon: Headset,     t:"24/7 Support",  d:"Always available"             },
  ];

  return (
    <div style={{ background:"#f8fbf9", minHeight:"100vh" }}>
      <div className="dest-hero page-hero">
        <div className="hero-blob hero-blob--1" />
        <div className="hero-blob hero-blob--2" />
        <button className="page-hero-back" onClick={onBack}>← Back</button>
        <div style={{ position:"relative", zIndex:2 }}>
          <span className="page-eyebrow">Explore India</span>
          <h1 className="page-title">Top Destinations</h1>
          <p className="page-sub">
            From Himalayan peaks to tropical coastlines — curated destinations for every kind of traveller.
          </p>
        </div>
      </div>

      <div className="section-inner">
        <div className="dest-grid">
          {DESTINATIONS.map(d => (
            <div key={d.name} className="dest-card" onClick={() => onOpenPackages(d.name)}>
              <div className="dest-card-img">
                <img src={d.image} alt={d.name} loading="lazy" />
                <div className="dest-card-img-overlay" />
                <div className="dest-card-info">
                  <span className="dest-card-name">{d.name}</span>
                  <span className="dest-card-country">🗺️ {d.country}</span>
                </div>
              </div>
              <div className="dest-card-body">
                <p className="dest-card-tagline">"{d.tagline}"</p>
                <p className="dest-card-cta">View Packages →</p>
              </div>
            </div>
          ))}
        </div>

        {/* Why strip */}
        <div style={{ marginTop:52, background:"#0d3d2c", borderRadius:24, padding:"40px 32px" }}>
          <h2 style={{ fontFamily:"'Playfair Display',serif", fontWeight:800, color:"#fff", fontSize:"1.3rem", marginBottom:24, textAlign:"center" }}>
            Why MakeBeeTrip?
          </h2>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))", gap:16 }}>
            {WHY_DEST.map(c => (
              <div key={c.t} style={{ textAlign:"center", padding:"16px 12px" }}>
                <span style={{ display:"flex", justifyContent:"center", marginBottom:8, color:"#4db882" }}>
                  <c.Icon size={28} strokeWidth={1.5} />
                </span>
                <p style={{ fontWeight:700, color:"#fff", margin:"0 0 4px", fontSize:".9rem" }}>{c.t}</p>
                <p style={{ fontSize:".78rem", color:"rgba(255,255,255,.5)", lineHeight:1.5 }}>{c.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ── About Page ── */
function AboutPage({ onBack }) {
  return (
    <div style={{ background:"#f8fbf9", minHeight:"100vh" }}>
      <div className="about-hero page-hero">
        <div className="hero-blob hero-blob--1" />
        <div className="hero-blob hero-blob--2" />
        <button className="page-hero-back" onClick={onBack}>← Back</button>
        <div style={{ position:"relative", zIndex:2 }}>
          <span className="page-eyebrow">Our Story</span>
          <h1 className="page-title">About MakeBeeTrip</h1>
          <p className="page-sub">Born from a love of travel. Built to make every journey extraordinary.</p>
        </div>
      </div>

      <div className="about-story">
        <div>
          <p className="section-eyebrow">Who We Are</p>
          <h2 className="section-title">India's Most Trusted Holiday Platform</h2>
          <p style={{ color:"#5a6e61", lineHeight:1.8, fontSize:".95rem", marginTop:14, fontWeight:300 }}>
            MakeBeeTrip was founded in 2018 by a group of passionate travellers tired of cookie-cutter
            holidays. We believed every trip should be as unique as the person taking it — crafted with
            care, priced fairly and supported every step of the way.
          </p>
          <p style={{ color:"#5a6e61", lineHeight:1.8, fontSize:".95rem", marginTop:12, fontWeight:300 }}>
            Today we've helped over 12,000 travellers discover India's most magnificent corners — from
            the backwaters of Kerala to the frozen passes of Spiti — with personalised itineraries,
            radical transparency and unwavering support.
          </p>
        </div>
        <div className="about-story-img">
          <img src="https://images.unsplash.com/photo-1522199755839-a2bacb67c546?w=600&q=80" alt="Our team" />
        </div>
      </div>

      <div className="about-stats">
        <div className="about-stats-grid">
          {[{n:"12K+",l:"Happy Travellers"},{n:"50+",l:"Destinations"},{n:"4.8★",l:"Avg Rating"},{n:"6 Yrs",l:"Experience"}].map(s => (
            <div key={s.l} className="about-stat">
              <span className="about-stat-n">{s.n}</span>
              <span className="about-stat-l">{s.l}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="about-team">
        <p className="section-eyebrow">The People</p>
        <h2 className="section-title">Meet the Team</h2>
        <div className="team-grid">
          {[
            {name:"Arjun Mehta",  role:"Founder & CEO",        emoji:"👨‍💼"},
            {name:"Priya Sharma", role:"Head of Operations",    emoji:"👩‍💼"},
            {name:"Rahul Nair",   role:"Lead Travel Designer",  emoji:"🗺️"},
            {name:"Sneha Kapoor", role:"Customer Happiness",    emoji:"😊"},
          ].map(m => (
            <div key={m.name} className="team-card">
              <div className="team-card-emoji">{m.emoji}</div>
              <p className="team-card-name">{m.name}</p>
              <p className="team-card-role">{m.role}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="about-values">
        <p className="section-eyebrow">Our Values</p>
        <h2 className="section-title" style={{ marginBottom:20 }}>What We Stand For</h2>
        {[
          {icon:"🌱", t:"Sustainable Tourism", d:"We partner only with eco-certified hotels and carbon-offset all vehicle transfers on every package."},
          {icon:"🤝", t:"Community First",      d:"We actively route spending to local guides, restaurants and artisans at every destination we visit."},
          {icon:"🔍", t:"Radical Transparency", d:"No hidden fees. Every single cost is itemised and presented before you pay a single rupee."},
        ].map(v => (
          <div key={v.t} className="value-card">
            <span className="value-card-icon">{v.icon}</span>
            <div>
              <p className="value-card-title">{v.t}</p>
              <p className="value-card-desc">{v.d}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── Contact Page ── */
function ContactPage({ onBack }) {
  const [form,   setForm]   = useState({ name:"", email:"", phone:"", destination:"", message:"" });
  const [errors, setErrors] = useState({});
  const [sent,   setSent]   = useState(false);

  const submit = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Required";
    if (!form.email.match(/^[^@]+@[^@]+\.[^@]+$/)) e.email = "Valid email required";
    if (!form.message.trim()) e.message = "Required";
    if (Object.keys(e).length) { setErrors(e); return; }
    setSent(true);
  };

  const renderContactField = (k, label, type = "text", ph, multi) => (
    <div className="form-field">
      <label className="form-label">{label}</label>
      {multi
        ? <textarea className={`form-input${errors[k] ? " form-input--err" : ""}`} rows={4} style={{ resize:"vertical" }} placeholder={ph} value={form[k]} onChange={e => setForm(v => ({ ...v, [k]: e.target.value }))} />
        : <input    className={`form-input${errors[k] ? " form-input--err" : ""}`} type={type} placeholder={ph} value={form[k]} onChange={e => setForm(v => ({ ...v, [k]: e.target.value }))} />
      }
      {errors[k] && <p className="form-err">{errors[k]}</p>}
    </div>
  );

  return (
    <div style={{ background:"#f8fbf9", minHeight:"100vh" }}>
      <div className="contact-hero page-hero">
        <div className="hero-blob hero-blob--1" />
        <div className="hero-blob hero-blob--2" />
        <button className="page-hero-back" onClick={onBack}>← Back</button>
        <div style={{ position:"relative", zIndex:2 }}>
          <span className="page-eyebrow">Get in Touch</span>
          <h1 className="page-title">Let's Plan Your Journey</h1>
          <p className="page-sub">Tell us your dream destination — we'll craft a perfect custom itinerary, free of charge.</p>
          <button
            className="contact-hero-cta"
            onClick={() => document.querySelector(".contact-inner")?.scrollIntoView({ behavior: "smooth", block: "start" })}
          >
            <span className="contact-hero-cta-icon">+</span>
            Request Custom Package
            <span className="contact-hero-cta-arrow">-&gt;</span>
          </button>
        </div>
      </div>

      <div className="contact-inner">
        {/* Info */}
        <div>
          <p className="section-eyebrow">Contact Details</p>
          <h2 className="section-title" style={{ marginBottom:22 }}>We'd Love to Help</h2>
          {[
  {
    icon: "📞",
    t: "Call Us",
    v: "9355471999",
    s: "Mon–Sat, 9am–8pm IST"
  },
  {
    icon: "✉️",
    t: "Email Us",
    v: "Holidays@makebeetrip.com",
    s: "Reply within 2 hours"
  },
  {
    icon: "🌐",
    t: "Website",
    v: "makebeetrip.com",
    s: "Visit MakeBeeTrip"
  }
].map(c => (
            <div key={c.t} className="contact-info-card">
              <span className="contact-info-icon">{c.icon}</span>
              <div>
                <p className="contact-info-title">{c.t}</p>
                <p className="contact-info-val">{c.v}</p>
                <p className="contact-info-sub">{c.s}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Form */}
        <div className="contact-form-card">
          {sent ? (
            <div style={{ textAlign:"center", padding:"32px 0" }}>
              <div style={{ fontSize:52, marginBottom:14 }}>🌴</div>
              <h3 style={{ fontFamily:"'Playfair Display',serif", fontWeight:800, color:"#0d3d2c", fontSize:"1.2rem", marginBottom:10 }}>
                Message Sent!
              </h3>
              <p style={{ color:"#5a6e61", fontSize:".9rem", lineHeight:1.75, marginBottom:22 }}>
                Thanks <strong>{form.name}</strong>! Our travel expert will reach out within 2 hours.
              </p>
              <button className="pkg-card-btn" onClick={() => { setSent(false); setForm({ name:"", email:"", phone:"", destination:"", message:"" }); }}>
                Send Another <ArrowRight size={15} />
              </button>
            </div>
          ) : (
            <>
              <h3 className="contact-form-title">Request a Custom Package</h3>
              {renderContactField("name", "Full Name *", "text", "Your full name")}
              {renderContactField("email", "Email Address *", "email", "you@email.com")}
              {renderContactField("phone", "Mobile Number", "tel", "Optional")}
              {renderContactField("destination", "Dream Destination", "text", "e.g. Ladakh, Bali, Bhutan...")}
              {renderContactField("message", "Message *", "text", "Tell us your travel dates, budget, group size and preferences...", true)}
              <button className="form-submit" onClick={submit}>Send Message →</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/* ── ROOT ── */

export default function Holiday() {
  usePageMeta(
  "Domestic & International Holiday Packages – MakeBeeTrip",
  "Explore curated holiday packages for Goa, Kerala, Kashmir, Himachal, Andaman, Dubai, Thailand and more. Book domestic & international tours on MakeBeeTrip.",
  "holiday packages, tour packages, domestic tour packages, international holiday packages, family holiday packages, honeymoon packages, goa tour, kerala tour, kashmir tour, dubai holiday"
);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const queryParams = useMemo(() => new URLSearchParams(searchParams.toString()), [searchParams]);
  const [page,        setPage]       = useState("home");
  const [selectedPkg, setSelectedPkg] = useState(null);
  const [bookingPkg,  setBookingPkg]  = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const auth   = useAuth();
  const userId = auth?.user?.id ?? auth?.user?.userId ?? null;
  const token  = auth?.token ?? null;

  const packageId = searchParams.get("package");
  const eventSlug = searchParams.get("event");
  const pageSlug = searchParams.get("page");

  useEffect(() => {
    if (!packageId) return;

    // No dummy seed — DetailPage fetches the real package from the API
    setSelectedPkg({ id: packageId });
    setSelectedEvent(null);
    setPage("detail");
    window.scrollTo({ top:0, behavior:"smooth" });
  }, [packageId]);

  useEffect(() => {
    if (!eventSlug || packageId) return;

    const event = CATEGORY_SHOWCASE.find(item => slugify(item.name) === eventSlug) || CATEGORY_SHOWCASE[0];
    setSelectedEvent(event);
    setSelectedPkg(null);
    setPage("event");
    window.scrollTo({ top:0, behavior:"smooth" });
  }, [eventSlug, packageId]);

  useEffect(() => {
    if (packageId || eventSlug) return;

    const directDestination = window.location.pathname.match(/\/holidays\/packages\/([^/]+)/)?.[1];
    if (directDestination) {
      setPage("home");
      setSelectedPkg(null);
      setSelectedEvent(null);
      return;
    }

    if (["destinations", "about", "contact"].includes(pageSlug)) {
      setPage(pageSlug);
    } else {
      setPage("home");
    }
    setSelectedPkg(null);
    setSelectedEvent(null);
  }, [packageId, eventSlug, pageSlug]);

  const nav = useCallback(p => {
    setSearchParams(p === "home" ? {} : { page: p });
    setPage(p);
    setSelectedPkg(null);
    setSelectedEvent(null);
    window.scrollTo({ top:0, behavior:"smooth" });
  }, [setSearchParams]);

  const viewPkg = useCallback(pkg => {
    setSearchParams({ package: String(pkg.id) });
    setSelectedPkg(pkg);
    setPage("detail");
    window.scrollTo({ top:0, behavior:"smooth" });
  }, [setSearchParams]);

  const viewEvent = useCallback(event => {
    setSearchParams({ event: slugify(event.name) });
    setSelectedEvent(event);
    setPage("event");
    window.scrollTo({ top:0, behavior:"smooth" });
  }, [setSearchParams]);

  const openPackages = useCallback((place) => {
  const slug = slugify(place);

  if (!slug) return;

  navigate(`/holidays/packages/${slug}`);
}, [navigate]);

  return (
    <div style={{ display:"flex", flexDirection:"column", minHeight:"100vh" }}>
      <main style={{ flex:1 }}>
        {page === "home"         && <HolidaysPage onView={viewPkg} onNav={nav} onEvent={viewEvent} onOpenPackages={openPackages} />}
        {page === "detail"       && selectedPkg && <DetailPage
  pkg={selectedPkg}
  onBack={() => nav("home")}
/>}
        {page === "event"        && selectedEvent && <EventPage event={selectedEvent} onBack={() => nav("home")} />}
        {page === "destinations" && <DestinationsPage onBack={() => nav("home")} onNav={nav} onOpenPackages={openPackages} />}
        {page === "about"        && <AboutPage onBack={() => nav("home")} />}
        {page === "contact"      && <ContactPage onBack={() => nav("home")} />}
      </main>
      
    </div>
  );
}
